import React, { useState, useEffect } from 'react';
import { getSalas } from "../../services/salas";
import './styles.css';

const RoomCarousel = ({ onSelectRoom, selectedRoom }) => {
  const [rooms, setRooms] = useState([]);

  useEffect(() => {
    const fetchSalas = async () => {
      try {
        const salas = await getSalas();
        setRooms(salas);
      } catch (error) {
        console.error("Erro ao buscar salas:", error);
      }
    };

    fetchSalas();
  }, []);

  return (
    <div className="carousel-wrapper">
      <div className="carousel">
        {rooms.map((room, index) => (
          <div
            key={index}
            className={`carousel-item ${selectedRoom && selectedRoom._id === room._id ? 'selected' : ''}`}
            onClick={() => onSelectRoom(room)}
          >
            <img src={room.imagem} alt={room.nome} className="room-image" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default RoomCarousel;
